// import { languageJson } from '@constantProMax'

const CURRENCY_ICON_CONFIG = {
    MYR: 'MY',
    THB: 'TH',
    SGD: 'SG',
    IDR: 'ID',
    VND: 'VN',
    BND: 'BN',
    MMK: 'MM',
    AUD: 'AU',
    PHP: 'PH',
    USDT: 'USDT',
    HKD: 'HK',
    INR: 'IN',
    KRW: 'KR',
    KHUSD: 'KH',
    USD: 'US',
};

const ICON_BASE = '/public/html/default_whitelabel/template/images/international-icon';

export function getCurrencyFromSelectedLanguage(lang) {
    let currencyObj = { currency: '', src: '', display: '' };

    if (!languageJson) return currencyObj;

    const match = languageJson.find((item) => lang === item.countryLanguageKey);
    if (!match) return currencyObj;

    currencyObj = { ...match };

    const currency = currencyObj.currency;
    const iconKey = CURRENCY_ICON_CONFIG[currency];
    const i18nLocaleKey = localStorage.getItem('language');
    if (iconKey) {
        currencyObj.src = `${ICON_BASE}/${iconKey}.png`;
        currencyObj.countryName = getTranslatedLanguageMsg(currency, i18nLocaleKey);
        currencyObj.countryEnglishName = getTranslatedLanguageMsg(currency, 'en');
    }

    return currencyObj;
}

export function getLanguageList() {
    let language = [];
    let languagesByCountry = [];
    let unSupportLang = [];

    const portalSettingsJson = window?.portalSettings;

    let currencyListData = languageJson;

    let suportLangFromSetting = window.languageList.map((lang) => lang.replace('-', '_').toUpperCase());
    for (let i = 0; i < currencyListData.length; i++) {
        currencyListData[i].isComingSoon = false;

        if (currencyListData[i].currency === 'MYR') {
            currencyListData[i].src = '/public/html/default_whitelabel/template/images/international-icon/MY.png';
            currencyListData[i].countryName = 'Malaysia';
            currencyListData[i].countryCode = 'my';
        } else if (currencyListData[i].currency === 'SGD') {
            currencyListData[i].src = '/public/html/default_whitelabel/template/images/international-icon/SG.png';
            currencyListData[i].countryName = 'Singapore';
            currencyListData[i].countryCode = 'sg';
        } else if (currencyListData[i].currency === 'IDR') {
            currencyListData[i].src = '/public/html/default_whitelabel/template/images/international-icon/ID.png';
            currencyListData[i].countryName = 'Indonesia';
            currencyListData[i].countryCode = 'id';
        } else if (currencyListData[i].currency === 'THB') {
            currencyListData[i].src = '/public/html/default_whitelabel/template/images/international-icon/TH.png';
            currencyListData[i].countryName = 'Thailand';
            currencyListData[i].countryCode = 'th';
        } else if (currencyListData[i].currency === 'VND') {
            currencyListData[i].src = '/public/html/default_whitelabel/template/images/international-icon/VN.png';
            currencyListData[i].countryName = 'Vietnam';
            currencyListData[i].countryCode = 'vn';
        } else if (currencyListData[i].currency === 'BND') {
            currencyListData[i].src = '/public/html/default_whitelabel/template/images/international-icon/BN.png';
            currencyListData[i].countryName = 'Brunei';
            currencyListData[i].countryCode = 'bn';
        } else if (currencyListData[i].currency === 'MMK') {
            currencyListData[i].src = '/public/html/default_whitelabel/template/images/international-icon/MM.png';
            currencyListData[i].countryName = 'Myanmar';
            currencyListData[i].countryCode = 'mm';
        } else if (currencyListData[i].currency === 'KHUSD') {
            currencyListData[i].src = '/public/html/default_whitelabel/template/images/international-icon/KH.png';
            currencyListData[i].countryName = 'Cambodia';
            currencyListData[i].countryCode = 'kh';
        } else if (currencyListData[i].currency === 'USD') {
            currencyListData[i].src = '/public/html/default_whitelabel/template/images/international-icon/global.png';
            currencyListData[i].countryName = 'International';
            currencyListData[i].countryCode = 'us';
        } else if (currencyListData[i].currency === 'AUD') {
            currencyListData[i].src = '/public/html/default_whitelabel/template/images/international-icon/AU.png';
            currencyListData[i].countryName = 'Australia';
            currencyListData[i].countryCode = 'au';
        } else if (currencyListData[i].currency === 'PHP') {
            currencyListData[i].src = '/public/html/default_whitelabel/template/images/international-icon/PH.png';
            currencyListData[i].countryName = 'Philippines';
            currencyListData[i].countryCode = 'ph';
        } else if (currencyListData[i].currency === 'USDT') {
            currencyListData[i].src = '/public/html/default_whitelabel/template/images/international-icon/USDT.png';
            currencyListData[i].countryName = 'Crypto';
            currencyListData[i].countryCode = 'crypto';
        } else if (currencyListData[i].currency === 'HKD') {
            currencyListData[i].src = '/public/html/default_whitelabel/template/images/international-icon/HK.png';
            currencyListData[i].countryName = 'Hong Kong';
            currencyListData[i].countryCode = 'hk';
        } else if (currencyListData[i].currency === 'BRL') {
            currencyListData[i].src = '/public/html/default_whitelabel/template/images/international-icon/BR.png';
            currencyListData[i].countryName = 'Brazil';
            currencyListData[i].countryCode = 'br';
        } else if (currencyListData[i].currency === 'BDT') {
            currencyListData[i].src = '/public/html/default_whitelabel/template/images/international-icon/BD.png';
            currencyListData[i].countryName = 'Bangladesh';
            currencyListData[i].countryCode = 'bd';
        } else if (currencyListData[i].currency === 'INR') {
            currencyListData[i].src = '/public/html/default_whitelabel/template/images/international-icon/IN.png';
            currencyListData[i].countryName = 'India';
            currencyListData[i].countryCode = 'in';
        } else if (currencyListData[i].currency === 'TWD') {
            currencyListData[i].src = '/public/html/default_whitelabel/template/images/international-icon/TW.png';
            currencyListData[i].countryName = 'Taiwan';
            currencyListData[i].countryCode = 'tw';
        } else if (currencyListData[i].currency === 'KRW') {
            currencyListData[i].src = '/public/html/default_whitelabel/template/images/international-icon/KR.png';
            currencyListData[i].countryName = 'Korean';
            currencyListData[i].countryCode = 'kr';
        } else if (currencyListData[i].currency === 'PGK') {
            currencyListData[i].src = '/public/html/default_whitelabel/template/images/international-icon/PG.png';
            currencyListData[i].countryName = 'Papua New Guinean';
            currencyListData[i].countryCode = 'pg';
        }

        if (
            portalSettingsJson?.features?.languageSwitcherSettings?.customCountryName &&
            portalSettingsJson.features.languageSwitcherSettings.customCountryName[currencyListData[i].currency]
        ) {
            currencyListData[i].countryName = portalSettingsJson.features.languageSwitcherSettings.customCountryName[currencyListData[i].currency];
        }

        if (
            portalSettingsJson?.features?.languageSwitcherSettings?.customFlagIcon &&
            portalSettingsJson.features.languageSwitcherSettings.customFlagIcon[currencyListData[i].currency]
        ) {
            currencyListData[i].src = portalSettingsJson.features.languageSwitcherSettings.customFlagIcon[currencyListData[i].currency];
        }

        if (suportLangFromSetting.includes(currencyListData[i].countryLanguageKey)) {
            language.push(copyLanguage(currencyListData[i]));
        } else {
            unSupportLang.push(copyLanguage(currencyListData[i]));
        }
    }

    const comingSoonCountry = portalSettingsJson?.features?.comingSoonCountry;
    if (comingSoonCountry) {
        const isComingSoonArr = unSupportLang.filter((a) => {
            if (comingSoonCountry[a.countryName]?.includes('ALL') || comingSoonCountry[a.countryName]?.includes(a.countryLanguageKey)) {
                a.isComingSoon = true;
                return true;
            }

            return false;
        });

        language = language.concat(isComingSoonArr);
    }

    languagesByCountry = groupLanguagesByCountry(language, comingSoonCountry);
    return languagesByCountry;

    function groupLanguagesByCountry(languages, comingSoonCountry) {
        const languagesByCountry = [];
        languages.forEach((language) => {
            const existedItem = languagesByCountry.find((y) => y.countryName === language.countryName);

            if (!existedItem) {
                languagesByCountry.push({
                    countryName: language.countryName,
                    currency: language.currency,
                    languages: [language],
                    isComingSoon: language.isComingSoon,
                    isComingSoonAll: comingSoonCountry?.[language.countryName]?.includes('ALL'),
                });
            } else if (!existedItem.isComingSoonAll) {
                existedItem.languages.push(language);
            }

            languagesByCountry.forEach((languageByCountry) =>
                languageByCountry.languages.forEach((language) => {
                    if (languageByCountry.isComingSoonAll) {
                        language.display = 'global:global.comingSoon';
                    }
                })
            );
        });

        return languagesByCountry;
    }

    function copyLanguage(language) {
        return {
            key: language.key,
            display: language.display,
            src: language.src,
            currency: language.currency,
            countryLanguageKey: language.countryLanguageKey,
            countryName: language.countryName,
            countryCode: language.countryCode,
            isComingSoon: language.isComingSoon,
        };
    }
}

export function getListOfSupportedLanguageForUrl() {
    const languageJsonList = languageJson;
    let listOfSupportedLanguage = [];
    let listOfSupportedcurrency = [];
    let listOfSupportedLanguageKey = [];
    let result = [];

    if (languageJsonList) {
        for (let i = 0; i < languageJsonList.length; i++) {
            const element = languageJsonList[i];
            let key = element.key;

            if (element.key === 'zh-cn') key = 'zh-CN';
            if (element.key === 'zh-hk') key = 'zh-HK';

            if (listOfSupportedLanguage.indexOf(element.countryLanguageKey) === -1) {
                listOfSupportedLanguage.push(element.countryLanguageKey);
            }

            if (listOfSupportedcurrency.indexOf(element.currency) === -1) {
                listOfSupportedcurrency.push(element.currency);
            }

            if (listOfSupportedLanguageKey.indexOf(key) === -1) {
                listOfSupportedLanguageKey.push(key);
            }
        }
    }

    result = listOfSupportedLanguage.concat(listOfSupportedcurrency, listOfSupportedLanguageKey);
    return result;
}

const getTranslatedLanguageMsg = (key, lang) => {
    return languageTranslate?.[lang]?.[key] ?? languageTranslate.default?.[key] ?? '';
};

const languageJson = [
    {
        key: 'en',
        display: 'English',
        currency: 'MYR',
        countryLanguageKey: 'EN_MY',
    },
    {
        key: 'zh-cn',
        display: '中文',
        currency: 'MYR',
        countryLanguageKey: 'ZH_MY',
    },
    {
        key: 'ms',
        display: 'Malay',
        currency: 'MYR',
        countryLanguageKey: 'MS_MY',
    },
    {
        key: 'vi-my',
        display: 'Tiếng Việt',
        currency: 'MYR',
        countryLanguageKey: 'VI_MY',
    },
    {
        key: 'en',
        display: 'English',
        currency: 'SGD',
        countryLanguageKey: 'EN_SG',
    },
    {
        key: 'zh-cn',
        display: '中文',
        currency: 'SGD',
        countryLanguageKey: 'ZH_SG',
    },
    {
        key: 'ms',
        display: 'Malay',
        currency: 'SGD',
        countryLanguageKey: 'MS_SG',
    },

    {
        key: 'en',
        display: 'English',
        currency: 'THB',
        countryLanguageKey: 'EN_TH',
    },
    {
        key: 'th',
        display: 'ไทย',
        currency: 'THB',
        countryLanguageKey: 'TH_TH',
    },
    {
        key: 'zh-cn',
        display: '中文',
        currency: 'THB',
        countryLanguageKey: 'ZH_TH',
    },
    {
        key: 'la',
        display: 'Laos',
        currency: 'THB',
        countryLanguageKey: 'LA_TH',
    },
    {
        key: 'en',
        display: 'English',
        currency: 'IDR',
        countryLanguageKey: 'EN_ID',
    },
    {
        key: 'id',
        display: 'Bhs Indonesia',
        currency: 'IDR',
        countryLanguageKey: 'ID_ID',
    },
    {
        key: 'zh-cn',
        display: '中文',
        currency: 'IDR',
        countryLanguageKey: 'ZH_ID',
    },

    {
        key: 'en',
        display: 'English',
        currency: 'VND',
        countryLanguageKey: 'EN_VN',
    },
    {
        key: 'vi-vn',
        display: 'Tiếng Việt',
        currency: 'VND',
        countryLanguageKey: 'VI_VN',
    },
    {
        key: 'th-vn',
        display: 'ไทย',
        currency: 'VND',
        countryLanguageKey: 'TH_VN',
    },
    {
        key: 'zh-vn',
        display: '中文',
        currency: 'VND',
        countryLanguageKey: 'ZH_VN',
    },
    {
        key: 'en',
        display: 'English',
        currency: 'BND',
        countryLanguageKey: 'EN_BN',
    },

    {
        key: 'zh-bn',
        display: '中文',
        currency: 'BND',
        countryLanguageKey: 'ZH_BN',
    },

    {
        key: 'bn',
        display: 'Brunei',
        currency: 'BND',
        countryLanguageKey: 'MS_BN',
    },
    {
        key: 'en',
        display: 'English',
        currency: 'MMK',
        countryLanguageKey: 'EN_MM',
    },
    {
        key: 'my',
        display: 'မြန်မာ',
        currency: 'MMK',
        countryLanguageKey: 'MY_MM',
    },

    {
        key: 'en',
        display: 'English',
        currency: 'KHUSD',
        countryLanguageKey: 'EN_KH',
    },
    {
        key: 'id-kh',
        display: 'Bhs Indonesia',
        currency: 'KHUSD',
        countryLanguageKey: 'ID_KH',
    },
    {
        key: 'km',
        display: 'ខ្មែរ',
        currency: 'KHUSD',
        countryLanguageKey: 'KM_KH',
    },
    {
        key: 'zh-cn',
        display: '中文',
        currency: 'KHUSD',
        countryLanguageKey: 'ZH_KH',
    },
    {
        key: 'ms-kh',
        display: 'Malay',
        currency: 'KHUSD',
        countryLanguageKey: 'MS_KH',
    },
    {
        key: 'en',
        display: 'English',
        currency: 'PHP',
        countryLanguageKey: 'EN_PH',
    },
    {
        key: 'tl',
        display: 'Tagalog',
        currency: 'PHP',
        countryLanguageKey: 'TL_PH',
    },
    {
        key: 'zh-cn',
        display: '中文',
        currency: 'PHP',
        countryLanguageKey: 'ZH_PH',
    },
    {
        key: 'en',
        display: 'English',
        currency: 'AUD',
        countryLanguageKey: 'EN_AU',
    },
    {
        key: 'zh-cn',
        display: '中文',
        currency: 'AUD',
        countryLanguageKey: 'ZH_AU',
    },
    {
        key: 'ms',
        display: 'Malay',
        currency: 'AUD',
        countryLanguageKey: 'MS_AU',
    },
    {
        key: 'en',
        display: 'English',
        currency: 'USD',
        countryLanguageKey: 'EN_US',
    },
    {
        key: 'zh-cn',
        display: '中文',
        currency: 'USD',
        countryLanguageKey: 'ZH_US',
    },
    {
        key: 'ms',
        display: 'Malay',
        currency: 'USD',
        countryLanguageKey: 'MS_US',
    },
    {
        key: 'th',
        display: 'ไทย',
        currency: 'USD',
        countryLanguageKey: 'TH_US',
    },
    {
        key: 'vi',
        display: 'Tiếng Việt',
        currency: 'USD',
        countryLanguageKey: 'VI_US',
    },
    {
        key: 'id',
        display: 'Bhs Indonesia',
        currency: 'USD',
        countryLanguageKey: 'ID_US',
    },
    {
        key: 'km',
        display: 'ខ្មែរ',
        currency: 'USD',
        countryLanguageKey: 'KM_US',
    },
    {
        key: 'en',
        display: 'English',
        currency: 'KRW',
        countryLanguageKey: 'EN_KR',
    },
    {
        key: 'kr',
        display: '한국어',
        currency: 'KRW',
        countryLanguageKey: 'KO_KR',
    },
    {
        key: 'en',
        display: 'English',
        currency: 'BRL',
        countryLanguageKey: 'EN_BR',
    },
    {
        key: 'zh',
        display: '中文',
        currency: 'BRL',
        countryLanguageKey: 'ZH_BR',
    },
    {
        key: 'pt',
        display: 'Portuguese',
        currency: 'BRL',
        countryLanguageKey: 'PT_BR',
    },
    {
        key: 'en',
        display: 'English',
        currency: 'USDT',
        countryLanguageKey: 'EN_ZZ',
    },
    {
        key: 'zh-cn',
        display: '中文',
        currency: 'USDT',
        countryLanguageKey: 'ZH_ZZ',
    },
    {
        key: 'th',
        display: 'ไทย',
        currency: 'USDT',
        countryLanguageKey: 'TH_ZZ',
    },
    {
        key: 'id',
        display: 'Bhs Indonesia',
        currency: 'USDT',
        countryLanguageKey: 'ID_ZZ',
    },
    {
        key: 'vi',
        display: 'Tiếng Việt',
        currency: 'USDT',
        countryLanguageKey: 'VI_ZZ',
    },
    {
        key: 'en',
        display: 'English',
        currency: 'HKD',
        countryLanguageKey: 'EN_HK',
    },
    {
        key: 'zh-hk',
        display: '中文',
        currency: 'HKD',
        countryLanguageKey: 'ZH_HK',
    },
    {
        key: 'en',
        display: 'English',
        currency: 'BDT',
        countryLanguageKey: 'EN_BD',
    },
    {
        key: 'bd',
        display: 'Bangladesh',
        currency: 'BDT',
        countryLanguageKey: 'BN_BD',
    },
    {
        key: 'en',
        display: 'English',
        currency: 'INR',
        countryLanguageKey: 'EN_IN',
    },
    {
        key: 'ta',
        display: 'தமிழ்',
        currency: 'INR',
        countryLanguageKey: 'TA_IN',
    },
    {
        key: 'hi',
        display: 'हिन्दी',
        currency: 'INR',
        countryLanguageKey: 'HI_IN',
    },
    {
        key: 'ja',
        display: 'Japanese',
        currency: 'KHUSD',
        countryLanguageKey: 'JA_KH',
    },
    {
        key: 'ko',
        display: 'Korean',
        currency: 'KHUSD',
        countryLanguageKey: 'KO_KH',
    },
    {
        key: 'id',
        display: 'Bhs Indonesia',
        currency: 'KHUSD',
        countryLanguageKey: 'ID_KH',
    },
    {
        key: 'th',
        display: 'ไทย',
        currency: 'KHUSD',
        countryLanguageKey: 'TH_KH',
    },
    {
        key: 'vi',
        display: 'Tiếng Việt',
        currency: 'KHUSD',
        countryLanguageKey: 'VI_KH',
    },
    {
        key: 'en',
        display: 'Taiwan',
        currency: 'TWD',
        countryLanguageKey: 'EN_TW',
    },
    {
        key: 'zh',
        display: 'Taiwan',
        currency: 'TWD',
        countryLanguageKey: 'ZH_TW',
    },
    {
        key: 'bn-my',
        display: 'বাংলা',
        currency: 'MYR',
        countryLanguageKey: 'BN_MY',
    },
    {
        key: 'en',
        display: 'English',
        currency: 'PGK',
        countryLanguageKey: 'EN_PG',
    },
];

const languageTranslate = {
    default: {
        MYR: 'Malaysia',
        THB: 'Thailand',
        SGD: 'Singapore',
        IDR: 'Indonesia',
        VND: 'Vietnam',
        BND: 'Brunei',
        KHUSD: 'Cambodia',
        AUD: 'Australia',
        MMK: 'Myanmar',
        PHP: 'Philippines',
        HKD: 'Hong Kong',
        INR: 'India',
        KRW: 'Korea',
        USD: 'International',
    },

    my: {
        MYR: 'မလေးရှား',
        THB: 'ထိုင်း',
        SGD: 'စင်္ကာပူ',
        IDR: 'အင်ဒိုနီးရှား',
        VND: 'ဗီယက်နမ်',
        BND: 'ဘရူနိုင်း',
        KHUSD: 'ကမ္ဘောဒီးယား',
        AUD: 'ဩစတြေးလျား',
        MMK: 'မြန်မာ',
        PHP: 'ဖိလစ်ပိုင်',
        HKD: 'ဟောင်ကောင်',
        INR: 'အိန္ဒိယ',
        KRW: 'တောင်ကိုရီးယား',
    },

    bn: {
        SGD: 'Singapura',
        KHUSD: 'Kemboja',
        PHP: 'Filipina',
        KRW: 'Korea Selatan',
    },

    id: {
        SGD: 'Singapura',
        KHUSD: 'Kamboja',
        PHP: 'Filipina',
        KRW: 'Korea Selatan',
    },

    km: {
        MYR: 'ម៉ាឡេស៊ី',
        THB: 'ថៃ',
        SGD: 'សិង្ហបុរី',
        IDR: 'ឥណ្ឌូនេស៊ី',
        VND: 'វៀតណាម',
        BND: 'ប៊្រុយណេ',
        KHUSD: 'កម្ពុជា',
        AUD: 'អូស្ត្រាលី',
        PHP: 'ហ្វីលីពីន',
        HKD: 'ហុងកុង',
        INR: 'ឥណ្ឌា',
        KRW: 'កូរ៉េខាងត្បូង',
        MMK: 'မြန်မာ',
    },

    ms: {
        SGD: 'Singapura',
        KHUSD: 'Kemboja',
        PHP: 'Filipina',
        KRW: 'Korea Selatan',
    },

    th: {
        MYR: 'มาเลเซีย',
        THB: 'ไทย',
        SGD: 'สิงคโปร์',
        IDR: 'อินโดนีเซีย',
        VND: 'เวียดนาม',
        BND: 'บรูไน',
        KHUSD: 'กัมพูชา',
        AUD: 'ออสเตรเลีย',
        PHP: 'ฟิลิปปินส์',
        HKD: 'ฮ่องกง',
        INR: 'อินเดีย',
        KRW: 'เกาหลีใต้',
        MMK: 'เมียนมา',
    },

    tl: {
        PHP: 'Pilipinas',
        KRW: 'South Korea',
    },

    vi: {
        THB: 'Thái Lan',
        VND: 'Việt Nam',
        KHUSD: 'Campuchia',
        AUD: 'Úc',
        HKD: 'Hồng Kông',
        INR: 'Ấn Độ',
        KRW: 'Hàn Quốc',
    },

    ta: {
        MYR: 'மலேசியா',
        THB: 'தாய்லாந்து',
        SGD: 'சிங்கப்பூர்',
        IDR: 'இண்டோனேசியா',
        VND: 'வியட்நாம்',
        BND: 'புரூனேய்',
        KHUSD: 'கம்போடியா',
        AUD: 'ஆஸ்திரேலியா',
        MMK: 'மியான்மார்',
        PHP: 'பிலிப்பைன்ஸ்',
        HKD: 'ஹொங்கொங்க்',
        INR: 'இந்தியா',
        KRW: 'தென் கொரியா',
    },

    hi: {
        MYR: 'मलेशिया',
        THB: 'थाईलैंड',
        SGD: 'सिंगापुर',
        IDR: 'इंडोनेशिया',
        VND: 'वियतनाम',
        BND: 'ब्रुनेई',
        KHUSD: 'कंबोडिया',
        AUD: 'ऑस्ट्रेलिया',
        MMK: 'म्यांमार',
        PHP: 'फिलीपींस',
        HKD: 'हांगकांग',
        INR: 'भारत',
        KRW: 'दक्षिण कोरिया',
    },

    ko: {
        KRW: 'Korean',
    },

    au: {
        KRW: 'Korean',
    },

    ph: {
        KRW: 'Korean',
    },

    in: {
        KRW: 'Korean',
    },
};

export const getCountryLanguageKeyFromCurrency = (currency) => {
    const foundMatchedLanguage = languageJson.find((item) => item.currency === currency);
    return foundMatchedLanguage.countryLanguageKey;
};
